<template>
  <div class="product-features-block is-flex justify-content-between pv20"  v-if="product && (product.product_cannabis_attributes || product.product_thc_cbd_levels)">
    <div
      v-if="product && product.product_cannabis_attributes"
      class="product-feature is-flex is-flex-column justify-content-between align-items-center">
      <div class="mt15 feature-text" v-text="product.product_cannabis_attributes.product_form"></div>
    </div>
    <div
      v-if="product && product.product_cannabis_attributes"
      class="product-feature is-flex is-flex-column justify-content-between align-items-center">
      <img v-if="product.product_cannabis_attributes" :src="plant_type[product.product_cannabis_attributes.plant_type]" :alt="product.product_cannabis_attributes.plant_type">
      <div class="feature-text" v-text="product.product_cannabis_attributes.plant_type"></div>
    </div>

    <div
      v-if="product && thc"
      class="product-feature is-flex is-flex-column justify-content-between align-items-center">
      <span class="">THC</span>
      <div class="feature-text">{{ thc }}</div>
    </div>
    <div
       v-if="product && cbd"
      class="product-feature is-flex is-flex-column justify-content-between align-items-center">
      <span class="">CBD</span>
      <div class="feature-text">{{ cbd }}</div>
    </div>
  </div>
</template>


<script>
import Env from "@/env";
import Helpers from '@/Components/Helpers/Helpers';
export default {
  name: 'ProductDetailFeatures',
  data() {
    return {

    };
  },
  props: ['product'],
  computed: {
    
    product_form() {
      return Env.product_form;
    },
    plant_type() {
      return Env.product_type;
    },
    thc() {
      return Helpers.getTHCValue(this.product.productDetail);
    },
    cbd() {
      return Helpers.getCBDValue(this.product.productDetail);
    },
  },
  methods: {
  },
};
</script>

